import React from 'react'
import RequestButton from '../RequestButton'
import FeaturesAndBenefits from '../FeaturesAndBenefits'
import Footnotes from '../Footnotes'
import './styles.scss'

const ProductOverview = ({ product }) => {

  return (
    <div>
      <h2 className="features-mobile">Features and Benefits</h2>
      <FeaturesAndBenefits data={product.featuresAndBenefits} buildABand={product.hierarchyNode.show_build_a_band} />
      <Footnotes footnotes={product.footnotes} />
      {
        product.hierarchyNode.salesforce_code && product.hierarchyNode.salesforce_code !== "Unassigned" &&
        <div className="mt-5">
          <RequestButton node={product.hierarchyNode} />
        </div>
      }
    </div>
  )
}

export default ProductOverview